import React, { useEffect } from 'react';
import TerminalSection from './TerminalSection';

interface ServiceData {
  serviceId: string;
  priority: string;
  focusAreas: string[];
}

interface Capability {
  label: string;
  value: string;
  highlight?: boolean;
}

const Dashboard: React.FC = () => {
  useEffect(() => {
    const sections = document.querySelectorAll<HTMLElement>('.terminal-section');

    sections.forEach(section => {
      const delay = parseFloat(section.style.animationDelay || '0s') * 1000;
      setTimeout(() => {
        section.style.opacity = '1';
        section.style.transform = 'translateY(0)';
      }, 500 + delay);
    });
  }, []);

  const serviceData: ServiceData = {
    serviceId: "AINA-2025-0001",
    priority: "Premium",
    focusAreas: ["Technological Facilitation", "Concept Consultation", "Hospitality Innovation"]
  };

  const consoleLines: string[] = [
    "$ initializing ainaeco platform...",
    "$ loading core modules: digital_execution, procurement_solutions, idea_validation",
    "$ establishing global networks...",
    "$ status check: enterprise resources ready",
    "$ platform status: launching soon"
  ];

  const capabilities: Capability[] = [
    {
      label: "Strategic Consulting",
      value: "Concept consultation for hospitality innovations"
    },
    {
      label: "Technical Implementation", 
      value: "Technological facilitation for hospitality spaces"
    },
    {
      label: "Global Procurement",
      value: "Strategic international sourcing for events and businesses"
    },
    {
      label: "Contact",
      value: "hello@ainaeco.uk",
      highlight: true
    }
  ];

  return (
    <div className="dashboard">
      <div className="terminal">
        <div className="terminal-header">
          <div className="window-controls">
            <div className="window-btn close-btn"></div>
            <div className="window-btn minimize-btn"></div>
            <div className="window-btn maximize-btn"></div>
          </div>
          <div className="terminal-title">ainaeco.dashboard</div>
        </div>
        
        <div className="terminal-body">
          <TerminalSection
            delay="0.2s"
            icon="⬢"
            title="Service Platform"
            type="info"
            data={serviceData}
          />
          
          <TerminalSection
            delay="0.6s"
            icon="⟁"
            title="System Status"
            type="console"
            consoleLines={consoleLines}
          />
          
          <TerminalSection
            delay="1s"
            icon="◈"
            title="Business Capabilities"
            type="capabilities"
            capabilities={capabilities}
          />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
